export enum MENU_RENDER_VIEW_ENUM {
    NEW_TAB = "new_tab",//เปิดหน้าใหม่
    CURRENT_TAB = "current_tab" // อยู่ในหน้าเดิม
}

export enum WEBSITE_MENU {
    POLICY = 'POLICY',          // เกี่ยวกับนโยบายต่างๆ
    USER_GUIDE = 'USER_GUIDE',  // เกี่ยวกับผู้ใช้งานระบบ
    SITE_MENU = 'SITE_MENU'     // เมนูเว็บไซต์
}

export const website_menu_data: { label: string, value: string }[] = [
    {
        label: "เกี่ยวกับนโยบายต่างๆ", // i18n-ignore: translated at render site
        value: WEBSITE_MENU.POLICY
    },
    {
        label: "การมีส่วนร่วมของประชาชน", // i18n-ignore: translated at render site
        value: WEBSITE_MENU.USER_GUIDE
    },
    {
        label: "เมนูเว็บไซต์", // i18n-ignore: translated at render site
        value: WEBSITE_MENU.SITE_MENU
    },
]